import * as React from "react";
import PropTypes from "prop-types";
import Backbone from "backbone";
import Theme from "nx-components/Theme";
import Tile from "nexia_mobile/components/Tiles/Tile";
import BackboneListener from "nexia_mobile/components/BackboneListener";

const styles = {
  // Intentionally unprefixed. We use a fallback in Tile if grid is not supported
  list: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
    paddingBottom: Theme.Padding.SAFE_AREA_BOTTOM,
    overflow: "hidden",
  },
};

export default class TileList extends React.Component {
  static propTypes = {
    style: PropTypes.object,
    collection: PropTypes.instanceOf(Backbone.Collection),
  };

  render() {
    const { collection, style } = this.props;

    return (
      <div
        className="tile-wrap"
        style={{ ...styles.list, ...style }}
        data-component-name="TileList"
      >
        <BackboneListener
          listenTo={collection}
          events={["add", "remove", "reset", "sort", "sync"]}
          debounceRender
        >
          {() =>
            collection.map((model) => (
              <Tile // This component is cheap to render, so it's safe to use SizeMe
                key={model.get("id")}
                model={model}
              />
            ))
          }
        </BackboneListener>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TileList.jsx